import {InputText} from 'primereact/inputtext';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Redirect} from 'react-router-dom';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import AuthService from '../services/AuthService';
import UserService from '../services/UserService';
import BlockUi from './../components/waitPanel/BlockUi';
import TextValidatorUtils from '../components/utils/TextValidatorUtils';

class RemindPasswordContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.authService = new AuthService();
        this.userService = new UserService();
        this.state = {
            username: '',
            password: '',
            email: '',
            redirectToReferrer: true,
            authValid: true,
            showCaptcha: false,
            captchaPreventAction: false,
        };
        this.authValidValidator = new SimpleReactValidator(
            {
                validators: {
                    auth: {
                        // name the rule
                        message: ':attribute',
                        rule: (val, params, validator) => {
                            return this.state.authValid;
                        }, // optional
                        required: true,
                    },
                },
            },
            props.t
        );
    }
    componentDidMount() {
        super.componentDidMount();
        const values = queryString.parse(this.props.location.search);
        this.targetLocation = values.location;
        //Messages.multiReadPersistMessage(['login-page'], this.messages);
    }
    persistMessage(severity, summary, detail) {
        this.saveCookie(
            'login-container',
            JSON.stringify({
                severity,
                summary,
                detail,
            })
        );
    }
    handleFormSubmit(e) {
        e.preventDefault();
        const {t} = this.props;
        if (this.validator.allValid()) {
            this.blockUi();
            const isFirstLogin = this.props.type !== 'REMIND';
            new UserService()
                .sendLinkForGenerateNewPassword(this.state.email, isFirstLogin)
                .then(() => {
                    if (isFirstLogin) {
                        this.persistMessage('success', '', t('password.firstLoginInstruction'));
                    } else {
                        this.persistMessage('success', '', t('password.resetSuccessLabel'));
                    }
                    window.location.href = '/';
                })
                .catch(() => {
                    if (isFirstLogin) {
                        this.persistMessage('success', '', t('password.firstLoginInstruction'));
                    } else {
                        this.persistMessage('success', '', t('password.resetSuccessLabel'));
                    }
                    window.location.href = '/';
                });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.setState({
                valid: false,
            });
            this.forceUpdate();
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    render() {
        if (this.authService.loggedIn()) {
            return this.renderAfterAuth();
        } else {
            return this.renderBeforeAuth();
        }
    }

    renderAfterAuth() {
        const {redirectToReferrer} = this.state;
        if (redirectToReferrer === true) {
            return <Redirect to={this.targetLocation ? this.targetLocation : '/start'} />;
        }
        return <Redirect to={'/start'} />;
    }

    renderBeforeAuth() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div id='main-login'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        <div className='login-background-container'>
                            <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                            <form
                                className='login-container'
                                onSubmit={(e) => {
                                    if (!this.state.captchaPreventAction) {
                                        this.handleFormSubmit(e);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        if (!this.state.captchaPreventAction) {
                                            this.handleFormSubmit();
                                        }
                                    }
                                }}
                                //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                                noValidate
                            >
                                <div className='login-moya-logo-container'>
                                    <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                                </div>
                                <div className='login-welcome-text-container'>
                                    <span className='login-welcome-text'>
                                        {this.props.type === 'REMIND' ? t('password.didYouRemind') : t('password.firstLogin')}
                                    </span>
                                </div>
                                <div className='login-form-container'>
                                    <div className='reset-password-subtitle'>
                                        {this.props.type === 'REMIND'
                                            ? t('password.remindInstruction')
                                            : <span>
                                                {t('password.firstLoginInstruction')}
                                                <hr /> 
                                                {t('password.extended_password')}
                                            </span>
                                          
                                        }
                                    </div>
                                    <div className='login-label'>{t('password.email')}</div>
                                    <div location='user_field'>
                                        <InputText
                                            className='login-input'
                                            aria-label={t('password.email')}
                                            key={'email'}
                                            id={'email'}
                                            name={'email'}
                                            placeholder={''}
                                            style={{width: '100%'}}
                                            value={this.state.email}
                                            onChange={(e) => {
                                                if(TextValidatorUtils.checkIfLatinSign(e.nativeEvent.data) === true){
                                                this.handleChange('TEXT', undefined, e, undefined, '')}}}
                                            required={true}
                                            validator={this.validator}
                                            validators='required|email|max:50|latin_required'
                                        />
                                        <div aria-live='assertive' className='login-form-validation'>
                                            {this.validator.message(
                                                'email',
                                                t('password.email'),
                                                this.state.email,
                                                'required|email|max:50'
                                            )}
                                        </div>
                                    </div>
                                    <ActionButton
                                        label={t('password.send')}
                                        variant='login-button password-button blue'
                                        handleClick={this.handleFormSubmit}
                                        disabled={this.state.captchaPreventAction}
                                    />
                                    <ActionButton
                                        label={t('details.cancel')}
                                        variant='login-button password-button white'
                                        href={'/#/'}
                                        disabled={this.state.captchaPreventAction}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}
RemindPasswordContainer.propTypes = {
    onAfterLogin: PropTypes.func,
};
export default withTranslation()(RemindPasswordContainer);
